export interface UploadUrlInputValues {
  url: string;
}

export enum UploadUrlInputFields {
  url = "url",
}
